/**
 * How far a snap reaches, in both editors and the 3D gadget: a fixed distance
 * on screen, so zooming in always lets a precise placement escape a snap, and
 * never more than a foot, so a snap never jumps across a zoomed-out plan.
 */

/** The most a snap reaches (ft), however far the view zooms out. */
export const SNAP_MAX_FEET = 1;
/** How far a snap reaches on screen, in logical (pre-retina) pixels. */
export const SNAP_PIXELS = 6;

/** The snap reach (ft) at a zoom of `scale` px/ft. */
export const snapReach = (scale: number): number => Math.min(SNAP_MAX_FEET, SNAP_PIXELS / scale);
